import { ProjectItem } from '../../component/block'
import './index.css'


export const ProjectList =({data})=>{


    return(
        <div className='projects_list_div'>
            <div className='inner_list_div'>
                {
                    data.map((project, i)=>{
                        return(
                            <ProjectItem key={i} name={project.name} link={project.link} image={project.image} desc={project.desc}/>
                        )
                    })
                }
            </div>  
        </div>
    )
}